module.exports = __webpack_public_path__ + "static/media/jl-logo.3c8d0d0a.png";